import { TFunction } from 'i18next'
import { toast } from '@node-space/ui-components'
import { BaseErrorResponse } from 'types/beneficiaries'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import track from 'utils/tracker'

export const handleScheduleSuccess = (
  amplitudeProperties: Record<string, unknown>,
  t: TFunction,
  handleClose: () => void,
  isUpdate: boolean,
  customMessage?: string
) => {
  const event = isUpdate
    ? AmplitudeEvent.EOF_EDIT_EXPORT_INITIATE_SUCCESS
    : AmplitudeEvent.EOF_CREATE_EXPORT_INITIATE_SUCCESS

  track.Amp.track(event, amplitudeProperties)

  toast({
    header: isUpdate ? t('exports.scheduleUpdated') : t('exports.reportScheduled'),
    variant: 'success',
    body: customMessage || t('exports.checkYourMailDescription'),
  })

  handleClose()
}

export const handleScheduleError = (
  error: BaseErrorResponse,
  amplitudeProperties: Record<string, unknown>,
  isUpdate: boolean
) => {
  const event = isUpdate
    ? AmplitudeEvent.EOF_EDIT_EXPORT_INITIATE_ERROR
    : AmplitudeEvent.EOF_CREATE_EXPORT_INITIATE_ERROR

  track.Amp.track(event, {
    ...amplitudeProperties,
    error,
  })
}

export const buildBaseAmplitudeProperties = (overrides: Record<string, unknown> = {}) => ({
  category: AmplitudeEventCategory.MERCHANT_PORTAL,
  action: AmplitudeEventAction.LOAD,
  ...overrides,
})
